/**
@format
@flow
*/
import * as React from 'react';
import styled from 'styled-components';
import Fonts from './fonts/index';

type Props = $ReadOnly<{|
  /**
   * Typography type
   */
  primitive: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

  /**
   * Color for text
   */
  color: string,

  /**
   * Font size
   */
  fontSize: number,

  /**
   * Line height for text
   */
  lineHeight: number,

  /**
   * Text passed in
   */
  children: any,

  /**
   * Animated bool to trigger a transition
   */
  animated: boolean,
|}>;

const TextWrapper = styled.span`
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  font-family: ${Fonts.Nunito};
  margin: 0;
  ${({ animated }) => animated && `
    transition: all 350ms;
  `}
`;

/**
 * A basic text component for Body, Heading, and SubHeading
 */
export default function Text(props: Props): React$Node {
  const {
    children, primitive, color, fontSize, lineHeight, ...rest
  } = props;
  return (
    <TextWrapper
      as={primitive}
      color={color}
      fontSize={fontSize}
      lineHeight={lineHeight}
      {...rest}
    >
      {children}
    </TextWrapper>
  );
}
